import React from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import TextField from "@material-ui/core/TextField";
import { NotificationManager, NotificationContainer } from 'react-notifications';
import Button from "@material-ui/core/Button";
import IntlMessages from "../util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import logo from '../assets/coffeepass_web_logo_interior.png';
import {
    hideMessage,
    showAuthLoader,
    userSignIn,
    shopLoginAction, hideAuthLoader
} from "../actions";
import { MixpanelTrack, MixpanelEmail, MixpanelIdentify } from "../util/MixpanelHelper";
import ShopSelectDialog from "./ShopSelectDialog";
import {bindActionCreators} from "redux";
import {SET_SELECTED_SHOP} from "../constants/ActionTypes";

class SignIn extends React.Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            showDialog: false
        }
    }

    componentDidMount() {
        MixpanelTrack("Visited SignIn Page")
    }

    componentDidUpdate(prevProps, prevState) {
        const isCoffeePassAdmin = localStorage.getItem("isCoffeePassAdmin")
        if(this.props.shop.shopId !== prevProps.shop.shopId) {
            if (this.props.showMessage) {
                setTimeout(() => {
                    this.props.hideMessage();
                }, 100);
            }
            if (this.props.shop != null && this.props.shop.shopId !== null && this.props.shop.shopId != "" && this.props.shop.shopId !== "multiple" && this.props.shop.shopId !== -1) {
                this.props.history.push('/app/overview');
            } else if (this.props.shop.shopId === "multiple") {
                this.setState({showDialog: true});
            } else if (isCoffeePassAdmin === "true") {
                this.props.history.push('/admin/overview');
            }
        }

    }

    render() {
        const {
            email,
            password
        } = this.state;
        const {showMessage, loader, alertMessage} = this.props;
        return (
            <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="app-login-main-content">

                    <div className="app-logo-content d-flex align-items-center justify-content-center">
                        <Link className="logo-lg" to="/" title="Jambo">
                            <img src={logo} className="appLogo" alt="logo" />
                        </Link>
                    </div>

                    <div className="app-login-content">
                        <div className="app-login-header mb-4">
                            <h1><IntlMessages id="appModule.email"/></h1>
                        </div>

                        <div className="app-login-form">
                            <form>
                                <fieldset>
                                    <TextField
                                        label={<IntlMessages id="appModule.email"/>}
                                        fullWidth
                                        onChange={(event) => this.setState({email: event.target.value})}
                                        defaultValue={email}
                                        margin="normal"
                                        className="mt-1 my-sm-3"
                                    />
                                    <TextField
                                        type="password"
                                        label={<IntlMessages id="appModule.password"/>}
                                        fullWidth
                                        onChange={(event) => this.setState({password: event.target.value})}
                                        defaultValue={password}
                                        margin="normal"
                                        className="mt-1 my-sm-3"
                                    />

                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        <Button onClick={() => {
                                            this.props.showAuthLoader();
                                            // this.props.userSignIn({email, password});
                                            this.props.shopLoginAction({
                                                email: email,
                                                password: password
                                            }, (resp) => {
                                                this.props.hideAuthLoader();
                                                if(resp.val == 'True') {
                                                    MixpanelIdentify(email)
                                                    MixpanelEmail(email)
                                                    MixpanelTrack('Successfully Logged in')
                                                } else {
                                                    NotificationManager.error("Invalid Email or Password", "Error", 6000)
                                                }
                                            }, (error) => {
                                                this.props.hideAuthLoader();
                                                NotificationManager.error("Error connecting to server. If you would, let us know the issue by emailing us at support@coffeepass.io. Thanks!", "Error", 6000)
                                            })
                                        }} variant="raised" color="primary" style={{backgroundColor: "#78A852"}}>
                                            <IntlMessages id="appModule.signIn"/>
                                        </Button>

                                        <Link className="anchor-cp" to="/signup">
                                            <IntlMessages id="signIn.signUp"/>
                                        </Link>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                    <ShopSelectDialog permissions={this.props.allPermissions} isDialogOpen={this.state.showDialog} handleClose={() => this.setState({showDialog: false})} onLogin={(shopId) => {
                        this.setState({showDialog: false});
                        this.props.setSelectedShop({permissions: this.props.allPermissions.find(s => s.shop_id == shopId), shopId, isFromLogin: true})
                    }} />

                </div>
                {
                    loader &&
                    <div className="loader-view">
                        <CircularProgress/>
                    </div>
                }
                {showMessage && console.log(alertMessage)}
                <NotificationContainer/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {loader, alertMessage, showMessage, authUser, shop, allPermissions} = state.auth;
    return {loader, alertMessage, showMessage, authUser, shop, allPermissions}
};
const mapDispatchToProps = (dispatch) => {
    const boundActions = bindActionCreators({userSignIn, hideMessage, showAuthLoader, shopLoginAction, hideAuthLoader}, dispatch);
    return {
        setSelectedShop: (value) => dispatch({ type: SET_SELECTED_SHOP, payload: value }),
        ...boundActions
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
